/**
 * Общие TypeScript типы для Work Order Preview.
 * Выделены по SRP/DRY — используются в TasksPage, AiWorkOrderModal, JiraTaskSelector.
 */

export interface CandidatePort {
  id: string
  name: string
  connector_type?: string | null
}

export interface SerialVerificationRow {
  serial: string
  status: 'FOUND' | 'NOT_FOUND'
  equipment_id?: string
  equipment_name?: string
  rack_id?: number
}

export interface WorkOrderItemPreview {
  item_type: string
  description: string
  metadata?: Record<string, unknown>
  has_unresolved: boolean
}

export interface WorkOrderPreview {
  title: string
  description?: string
  datacenter_code?: string
  jira_ticket_id?: string
  items: WorkOrderItemPreview[]
  unresolved_notes?: string
  jira_metadata?: Record<string, unknown>
  /** Максимальный уровень автономии AI (1 = advisory: создание наряда запрещено). */
  allowed_autonomy_level?: number
  serial_verification?: SerialVerificationRow[]
  /** Same string POST commit would 409 with. Null/absent = Create may open Review Gate. */
  commit_block_reason?: string | null
}

export interface WorkOrderItem {
  id: string
  item_type: string
  description: string
  status: string
  sequence_number: number
  metadata_json?: Record<string, unknown>
}

export interface WorkOrder {
  id: string
  datacenter_code: string
  title: string
  description: string
  status: string
  created_at: string
  jira_ticket_id?: string
  items: WorkOrderItem[]
}

export const STAGE_LABELS: Record<string, string> = {
  PLANNING: 'Планирование',
  REVIEW: 'Согласование',
  EXECUTION: 'В работе',
  MERGED: 'Завершено',
  CANCELLED: 'Отменено',
}

export const ITEM_TYPE_ICONS: Record<string, string> = {
  INSTALL_EQUIPMENT: '🖥️',
  REMOVE_EQUIPMENT: '🗑️',
  PATCH_CABLE: '🔌',
  UNPATCH_CABLE: '✂️',
  MOVE_EQUIPMENT: '📦',
  MOVE_RACK: '🗄️',
  CUSTOM: '📝',
}
